import * as React from 'react';

import { TextField } from '@cian/components';

import { InlineLabel, InlineParam } from '../../../markup';

interface IPhoneProps {
  phone: string | undefined;
  onPhoneChange(phone: string | undefined): void;
}

export class Phone extends React.Component<IPhoneProps> {
  public render() {
    return (
      <>
        <InlineLabel>+7</InlineLabel>
        <InlineParam>
          <TextField type="phone" value={this.props.phone || ''} mask="9999999999" onValueChange={this.handleChange} />
        </InlineParam>
      </>
    );
  }

  private handleChange = (value: string) => {
    this.props.onPhoneChange(value.replace(/\D+/g, '') || undefined);
  };
}
